import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { ICircleObject } from "../objects";
import { AbstractTexturedShapeDrawableObjectEditor } from "./AbstractTexturedShapeDrawableObjectEditor";

export class CircleObjectEditor extends AbstractTexturedShapeDrawableObjectEditor<ICircleObject> {
  constructor(source: ICircleObject | CircleObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
  }

  getTypeName(): string {
    return "円";
  }

  clone(): IFormatObjectEditable {
    return new CircleObjectEditor(this);
  }
}
